import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { JockeyAndTrainerDetails } from 'src/domains/sportsbook/webview/components/raceSummary/templates/runnerInfo/JockeyAndTrainerDetails';
import { withConfig } from 'src/withConfig';

interface RaceSummaryRowPropsType {
    isNonRunner?: boolean;
    variant: DefaultComponentVariantType | null;
}

const setRaceSummaryRow = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            gap: ${theme.star.gap.small};
            padding: ${theme.star.padding.small};
        `;
    }
    return css`
        border-bottom: 1px solid  ${theme.star.raceSummary.borderColor};
        @media ${theme.star.mediaQuery.tablet} {
            border-left: 1px solid  ${theme.star.raceSummary.borderColor};
        }
    `;
};

export const RaceSummaryRow = withConfig(theme => styled('li', { label: 'RaceSummaryRow' })<RaceSummaryRowPropsType>`
    ${({ variant }): SerializedStyles=> setRaceSummaryRow(variant, theme)};
    background-color: ${theme.star.raceSummary.bgColor};
    color: ${theme.star.raceSummary.txtColor};
    display: flex;
    flex-flow: row nowrap;
    min-height: 72px;
    justify-content: space-between;
    opacity: ${({ isNonRunner }): number => isNonRunner === true ? 0.4 : 1};
    position: relative;
    @media ${theme.star.mediaQuery.tablet} {
        min-height: 64px;
    }
`);

export const CellRunner = styled('div', { label: 'CellRunner' })`
    align-items: center;
    align-self: stretch;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
    gap: 8px;
    justify-content: start;
    min-width: 120px;
    overflow: hidden;
    padding: 8px 12px;
`;

export const SilkCellRaceSummaryWrapper = styled('div', { label: 'SilkCellRaceSummaryWrapper' })`
    align-items: center;
    display: flex;
    flex: 0 0 36px;
    justify-content: center;
`;

export const JockeyAndTrainerDetailsBox = withConfig(theme => styled(JockeyAndTrainerDetails, { label: 'JockeyAndTrainerDetailsBox' })`
    align-items: flex-start;
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    font-size: ${theme.star.fontSize.xSmall};
    justify-content: center;
    overflow: hidden;
    width: 100%;
`);
